import { IBaseApiAction, IBaseApiStoreState, BaseApiStore } from "./BaseApiStore";
import { Dispatcher } from "./Dispatcher";
import { ResponseState } from "./ResponseState";
import { ActionType } from "./ActionType";

export interface IPayloadAction<TPayload> extends IBaseApiAction {
    payload?: TPayload;
}

export interface IPayloadStoreState<TPayload> extends IBaseApiStoreState {
    payload?: TPayload;
}

export class PayloadStore<TPayload> extends BaseApiStore<IPayloadStoreState<TPayload>, IPayloadAction<TPayload>> {
    constructor(dispatcher: Dispatcher<IPayloadAction<TPayload>>) {
        super(dispatcher);
    }

    protected getDefaultState(): IPayloadStoreState<TPayload> {
        return { responseState: ResponseState.Empty };
    }

    public getPayload(): TPayload {
        return this.getState().payload;
    }

    protected onDispatch(action: IPayloadAction<TPayload>): void {
        switch (action.actionType) {
            case ActionType.Loading:
                this.setState({ responseState: ResponseState.Requested });
                break;
            case ActionType.Success:
                this.setState({ payload: null });
                this.setState({ payload: action.payload, responseState: ResponseState.Received });
                break;
            case ActionType.FlushStore:
                this.setState({ payload: null, responseState: ResponseState.Empty });
                break;
            case ActionType.Update:
                this.setState({ payload: action.payload });
                break;
            default:
                throw new Error("PayloadStore<TPayload>.onDispatch: Unexpected action type");
        }
    }
}
